export default __webpack_public_path__ + "static/birthcontrol2-3c47df9b595eaac5dda5772fd57402f1.png";